import React from 'react';
import './style.scss';
import PropTypes from "prop-types";
import {FormattedMessage} from 'react-intl';


export default class ItemDetails extends React.Component {
    static propTypes = {
        packageDescription: PropTypes.string.isRequired,
    };

  render() {
    return (
        <div className="ItemDetails">
            <div className="Title"><FormattedMessage
            id="GoSendPartner.ItemDescription"
            /></div>
            <div className="Description">{this.props.packageDescription}</div>
        </div>
    );
  }
}

